import styled from "styled-components";

const Skeleton = styled.div<{ height: string }>`
  height: ${({ height }) => `${height}px`};
  background-color: ${({ theme }) => theme.colors.gray200};
`;

export default Skeleton;
